import _regeneratorRuntime from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _defineProperty from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _slicedToArray from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { FlattenedEncrypt, unprotected } from '../flattened/encrypt.js';
import { JWEInvalid } from '../../util/errors.js';
import generateCek from '../../lib/cek.js';
import isDisjoint from '../../lib/is_disjoint.js';
import encryptKeyManagement from '../../lib/encrypt_key_management.js';
import { encode as base64url } from '../../runtime/base64url.js';
import validateCrit from '../../lib/validate_crit.js';

var IndividualRecipient =
/*#__PURE__*/
function () {
  function IndividualRecipient(enc, key, options) {
    _classCallCheck(this, IndividualRecipient);

    this.parent = enc;
    this.key = key;
    this.options = options;
  }

  _createClass(IndividualRecipient, [{
    key: "setUnprotectedHeader",
    value: function setUnprotectedHeader(unprotectedHeader) {
      if (this.unprotectedHeader) {
        throw new TypeError('setUnprotectedHeader can only be called once');
      }

      this.unprotectedHeader = unprotectedHeader;
      return this;
    }
  }, {
    key: "addRecipient",
    value: function addRecipient() {
      var _this$parent;

      return (_this$parent = this.parent).addRecipient.apply(_this$parent, arguments);
    }
  }, {
    key: "encrypt",
    value: function encrypt() {
      var _this$parent2;

      return (_this$parent2 = this.parent).encrypt.apply(_this$parent2, arguments);
    }
  }, {
    key: "done",
    value: function done() {
      return this.parent;
    }
  }]);

  return IndividualRecipient;
}();

export var GeneralEncrypt =
/*#__PURE__*/
function () {
  function GeneralEncrypt(plaintext) {
    _classCallCheck(this, GeneralEncrypt);

    this._recipients = [];
    this._plaintext = plaintext;
  }

  _createClass(GeneralEncrypt, [{
    key: "addRecipient",
    value: function addRecipient(key, options) {
      var recipient = new IndividualRecipient(this, key, {
        crit: options === null || options === void 0 ? void 0 : options.crit
      });

      this._recipients.push(recipient);

      return recipient;
    }
  }, {
    key: "setProtectedHeader",
    value: function setProtectedHeader(protectedHeader) {
      if (this._protectedHeader) {
        throw new TypeError('setProtectedHeader can only be called once');
      }

      this._protectedHeader = protectedHeader;
      return this;
    }
  }, {
    key: "setSharedUnprotectedHeader",
    value: function setSharedUnprotectedHeader(sharedUnprotectedHeader) {
      if (this._unprotectedHeader) {
        throw new TypeError('setSharedUnprotectedHeader can only be called once');
      }

      this._unprotectedHeader = sharedUnprotectedHeader;
      return this;
    }
  }, {
    key: "setAdditionalAuthenticatedData",
    value: function setAdditionalAuthenticatedData(aad) {
      this._aad = aad;
      return this;
    }
  }, {
    key: "encrypt",
    value: function () {
      var _encrypt = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(options) {
        var _a, _b, _c, _this$_recipients, recipient, flattened, _jwe, enc, i, _recipient, joseHeader, alg, cek, jwe, _i, _recipient2, target, _joseHeader, p2c, _flattened, _ref, encryptedKey, parameters;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this._recipients.length) {
                  _context.next = 2;
                  break;
                }

                throw new JWEInvalid('at least one recipient must be added');

              case 2:
                options = {
                  deflateRaw: options === null || options === void 0 ? void 0 : options.deflateRaw
                };

                if (!(this._recipients.length === 1)) {
                  _context.next = 15;
                  break;
                }

                _this$_recipients = _slicedToArray(this._recipients, 1), recipient = _this$_recipients[0];
                _context.next = 7;
                return new FlattenedEncrypt(this._plaintext).setAdditionalAuthenticatedData(this._aad).setProtectedHeader(this._protectedHeader).setSharedUnprotectedHeader(this._unprotectedHeader).setUnprotectedHeader(recipient.unprotectedHeader).encrypt(recipient.key, _objectSpread({}, recipient.options, options));

              case 7:
                flattened = _context.sent;
                _jwe = {
                  ciphertext: flattened.ciphertext,
                  iv: flattened.iv,
                  recipients: [{}],
                  tag: flattened.tag
                };
                if (flattened.aad) _jwe.aad = flattened.aad;
                if (flattened.protected) _jwe.protected = flattened.protected;
                if (flattened.unprotected) _jwe.unprotected = flattened.unprotected;
                if (flattened.encrypted_key) _jwe.recipients[0].encrypted_key = flattened.encrypted_key;
                if (flattened.header) _jwe.recipients[0].header = flattened.header;
                return _context.abrupt("return", _jwe);

              case 15:
                i = 0;

              case 16:
                if (!(i < this._recipients.length)) {
                  _context.next = 41;
                  break;
                }

                _recipient = this._recipients[i];

                if (isDisjoint(this._protectedHeader, this._unprotectedHeader, _recipient.unprotectedHeader)) {
                  _context.next = 20;
                  break;
                }

                throw new JWEInvalid('JWE Protected, JWE Shared Unprotected and JWE Per-Recipient Header Parameter names must be disjoint');

              case 20:
                joseHeader = _objectSpread({}, this._protectedHeader, this._unprotectedHeader, _recipient.unprotectedHeader);
                alg = joseHeader.alg;

                if (!(typeof alg !== 'string' || !alg)) {
                  _context.next = 24;
                  break;
                }

                throw new JWEInvalid('JWE "alg" (Algorithm) Header Parameter missing or invalid');

              case 24:
                if (!(alg === 'dir' || alg === 'ECDH-ES')) {
                  _context.next = 26;
                  break;
                }

                throw new JWEInvalid('"dir" and "ECDH-ES" alg may only be used with a single recipient');

              case 26:
                if (!(typeof joseHeader.enc !== 'string' || !joseHeader.enc)) {
                  _context.next = 28;
                  break;
                }

                throw new JWEInvalid('JWE "enc" (Encryption Algorithm) Header Parameter missing or invalid');

              case 28:
                if (enc) {
                  _context.next = 32;
                  break;
                }

                enc = joseHeader.enc;
                _context.next = 34;
                break;

              case 32:
                if (!(enc !== joseHeader.enc)) {
                  _context.next = 34;
                  break;
                }

                throw new JWEInvalid('JWE "enc" (Encryption Algorithm) Header Parameter must be the same for all recipients');

              case 34:
                validateCrit(JWEInvalid, new Map(), _recipient.options.crit, this._protectedHeader, joseHeader);

                if (!(joseHeader.zip !== undefined)) {
                  _context.next = 38;
                  break;
                }

                if (!(!this._protectedHeader || !this._protectedHeader.zip)) {
                  _context.next = 38;
                  break;
                }

                throw new JWEInvalid('JWE "zip" (Compression Algorithm) Header MUST be integrity protected');

              case 38:
                i++;
                _context.next = 16;
                break;

              case 41:
                cek = generateCek(enc);
                jwe = {
                  ciphertext: '',
                  iv: '',
                  recipients: [],
                  tag: ''
                };
                _i = 0;

              case 44:
                if (!(_i < this._recipients.length)) {
                  _context.next = 73;
                  break;
                }

                _recipient2 = this._recipients[_i];
                target = {};
                jwe.recipients.push(target);
                _joseHeader = _objectSpread({}, this._protectedHeader, this._unprotectedHeader, _recipient2.unprotectedHeader);
                p2c = _joseHeader.alg.startsWith('PBES2') ? 2048 + _i : undefined;

                if (!(_i === 0)) {
                  _context.next = 63;
                  break;
                }

                _context.next = 53;
                return new FlattenedEncrypt(this._plaintext).setAdditionalAuthenticatedData(this._aad).setContentEncryptionKey(cek).setProtectedHeader(this._protectedHeader).setSharedUnprotectedHeader(this._unprotectedHeader).setUnprotectedHeader(_recipient2.unprotectedHeader).setKeyManagementParameters({
                  p2c: p2c
                }).encrypt(_recipient2.key, _objectSpread({}, _recipient2.options, options, _defineProperty({}, unprotected, true)));

              case 53:
                _flattened = _context.sent;
                jwe.ciphertext = _flattened.ciphertext;
                jwe.iv = _flattened.iv;
                jwe.tag = _flattened.tag;
                if (_flattened.aad) jwe.aad = _flattened.aad;
                if (_flattened.protected) jwe.protected = _flattened.protected;
                if (_flattened.unprotected) jwe.unprotected = _flattened.unprotected;
                target.encrypted_key = _flattened.encrypted_key;
                if (_flattened.header) target.header = _flattened.header;
                return _context.abrupt("continue", 70);

              case 63:
                _context.next = 65;
                return encryptKeyManagement(((_a = _recipient2.unprotectedHeader) === null || _a === void 0 ? void 0 : _a.alg) || ((_b = this._protectedHeader) === null || _b === void 0 ? void 0 : _b.alg) || ((_c = this._unprotectedHeader) === null || _c === void 0 ? void 0 : _c.alg), enc, _recipient2.key, cek, {
                  p2c: p2c
                });

              case 65:
                _ref = _context.sent;
                encryptedKey = _ref.encryptedKey;
                parameters = _ref.parameters;
                target.encrypted_key = base64url(encryptedKey);
                if (_recipient2.unprotectedHeader || parameters) target.header = _objectSpread({}, _recipient2.unprotectedHeader, parameters);

              case 70:
                _i++;
                _context.next = 44;
                break;

              case 73:
                return _context.abrupt("return", jwe);

              case 74:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function encrypt(_x) {
        return _encrypt.apply(this, arguments);
      }

      return encrypt;
    }()
  }]);

  return GeneralEncrypt;
}();